import { openBlock as o, createElementBlock as t, createElementVNode as r } from "vue";
import { _ as n } from "./_plugin-vue_export-helper-dad06003.js";
const s = {}, i = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function l(c, e) {
  return o(), t("svg", i, e[0] || (e[0] = [
    r("path", {
      d: "M9.99963 7.50019V10.8335M9.99963 14.1669H10.008M8.84573 3.24329L1.99166 15.0821C1.61149 15.7388 1.4214 16.0671 1.4495 16.3366C1.474 16.5716 1.59714 16.7852 1.78828 16.9242C2.00741 17.0835 2.38679 17.0835 3.14556 17.0835H16.8537C17.6125 17.0835 17.9919 17.0835 18.211 16.9242C18.4021 16.7852 18.5253 16.5716 18.5498 16.3366C18.5779 16.0671 18.3878 15.7388 18.0076 15.0821L11.1535 3.24329C10.7747 2.58899 10.5853 2.26184 10.3382 2.15196C10.1227 2.05612 9.8766 2.05612 9.66105 2.15196C9.41394 2.26184 9.22454 2.58899 8.84573 3.24329Z",
      stroke: "currentColor",
      "stroke-width": "1.66667",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const _ = /* @__PURE__ */ n(s, [["render", l]]);
export {
  _ as A
};
